module.exports = __webpack_public_path__ + "img/alert.c6bdd774.svg";